import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import './CustomCursor.css'

export default function CustomCursor() {
  const cursorRef = useRef(null)
  const cursorFollowerRef = useRef(null)

  useEffect(() => {
    const cursor = cursorRef.current
    const follower = cursorFollowerRef.current
    
    // Check if device supports hover (not mobile)
    const hasHover = window.matchMedia('(hover: hover)').matches
    if (!hasHover) return

    let mouseX = 0
    let mouseY = 0
    let cursorX = 0
    let cursorY = 0
    let followerX = 0
    let followerY = 0

    const handleMouseMove = (e) => {
      mouseX = e.clientX
      mouseY = e.clientY
    }

    const animate = () => {
      // Cursor follows immediately
      cursorX += (mouseX - cursorX) * 0.5
      cursorY += (mouseY - cursorY) * 0.5
      
      // Follower follows with delay
      followerX += (mouseX - followerX) * 0.15
      followerY += (mouseY - followerY) * 0.15
      
      gsap.set(cursor, { x: cursorX, y: cursorY })
      gsap.set(follower, { x: followerX, y: followerY })
      
      requestAnimationFrame(animate)
    }

    // Handle hover states
    const handleMouseEnter = () => {
      gsap.to(cursor, { scale: 0.5, duration: 0.3 })
      gsap.to(follower, { scale: 1.5, duration: 0.3 })
    }

    const handleMouseLeave = () => {
      gsap.to(cursor, { scale: 1, duration: 0.3 })
      gsap.to(follower, { scale: 1, duration: 0.3 })
    }

    // Add listeners
    document.addEventListener('mousemove', handleMouseMove)
    animate()

    // Add hover listeners to interactive elements
    const interactiveElements = document.querySelectorAll('a, button, input, textarea, [role="button"]')
    interactiveElements.forEach((el) => {
      el.addEventListener('mouseenter', handleMouseEnter)
      el.addEventListener('mouseleave', handleMouseLeave)
    })

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      interactiveElements.forEach((el) => {
        el.removeEventListener('mouseenter', handleMouseEnter)
        el.removeEventListener('mouseleave', handleMouseLeave)
      })
    }
  }, [])

  return (
    <>
      <div className="cursor" ref={cursorRef}></div>
      <div className="cursor-follower" ref={cursorFollowerRef}></div>
    </>
  )
}
